import {base, baseConfig} from "../Services/api";

export function create(obj) {
    const conf = {
        method: 'POST',
        body: JSON.stringify(obj),
        ...baseConfig
    };

    return fetch(`${base}shopifytransactions`, conf);
}


export function get() {
    return fetch(`${base}shopifytransactions`, baseConfig);
}

export function getOne(id) {
    return fetch(`${base}shopifytransactions/${id}`, baseConfig);
}

export function update(id, obj) {
    const conf = {
        method: 'PUT',
        body: JSON.stringify(obj),
        ...baseConfig
    };
    return fetch(`${base}shopifytransactions/${id}`,conf);
}
